import { useCallback } from 'react';
import { useWfAuthStore } from '../stores/WfAuthStore';
import { useWfUserStore } from '../stores/WfUserStore';
import { useWfFilterStore } from '../stores/WfFilterStore';
import { useWfWorkplaceStore } from '../stores/WfWorkplaceStore';
import { useWfProductStore } from '../stores/WfProductStore';
import useWfSecurityRepo from '../repository/WfSecurityRepo';

function useWfSecurityService() {
  const { setAuthenticated } = useWfAuthStore();
  const { setUser, setSelectedUser } = useWfUserStore();
  const { postLoginRequest, postLogoutRequest } = useWfSecurityRepo();
  const { setAvailableWorkplaces, setSelectedWorkplace } = useWfWorkplaceStore();
  const { setProducts, setSelectedProduct, setProductDetails } = useWfProductStore();
  const { resetFilters } = useWfFilterStore();

  const wfLoginUser = useCallback(
    async (username: string, password: string) => {
      const response = await postLoginRequest({ username, password });
      if (response !== null) {
        setAuthenticated(true);
      } else {
        setAuthenticated(false);
      }
    },
    [postLoginRequest, setAuthenticated]
  );

  const wfLogoutUser = useCallback(async () => {
    await postLogoutRequest().then(() => {
      setAuthenticated(false);
      setAvailableWorkplaces([]);
      setSelectedWorkplace(null);
      setProducts([]);
      setSelectedProduct(null);
      setProductDetails(null);
      resetFilters();
      setUser(null);
      setSelectedUser(null); // 前ユーザーが選択した代理予約FEを引き継がないようにリセット
    });
  }, [
    postLogoutRequest,
    setAuthenticated,
    setAvailableWorkplaces,
    setSelectedWorkplace,
    setProducts,
    setSelectedProduct,
    setProductDetails,
    resetFilters,
    setUser,
    setSelectedUser,
  ]);

  return {
    wfLoginUser,
    wfLogoutUser,
  };
}

export default useWfSecurityService;
